module.exports = __webpack_public_path__ + "media/img/apple-icon-152x152-91017eb4e2e93c7ac2f68b35117cffaa.png";